/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { JobLogResponse } from '../types/JobLog';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type DocChecksLogsListRequest = {} | null | undefined;
export type DocChecksLogsListResponse = JobLogResponse[];

export type DocChecksLogsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: date__gt
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  date__gt?: string;

  /**
   * ```yaml
   * in: query
   * name: date__lt
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  date__lt?: string;

  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * required: true
   * ```
   */
  id?: number;

  /**
   * ```yaml
   * in: query
   * name: level
   * schema:
   *   type: integer
   *   enum:
   *     - 1
   *     - 2
   *     - 3
   *     - 4
   *     - 5
   *     - 6
   * description: |-
   *   * `1` - Fatal
   *   * `2` - Error
   *   * `3` - Warn
   *   * `4` - Info
   *   * `5` - Debug
   *   * `6` - Trace
   * ```
   */
  level?: '1' | '2' | '3' | '4' | '5' | '6';

  /**
   * ```yaml
   * in: query
   * name: level__in
   * schema:
   *   type: array
   *   items:
   *     type: integer
   * description: Více hodnot lze oddělit čárkami.
   * explode: false
   * style: form
   * ```
   */
  level__in?: number[];
};

/**
 * GET /dmx-server/doc_checks/{id}/logs/
 *
 * ```yaml
 * operationId: doc_checks_logs_list
 * description: >-
 *   Slouží jako základ pro vytváření ViewSets pro zobrazení logů nad konkrétními
 *   objekty, např.
 *
 *   nad objednávkami, kontrolami.
 *
 *
 *   Nepovinne filtry
 *
 *   level - logovaci hladina je v rozmezi 1 - 6
 *    - Fatal = 1
 *    - Error = 2
 *    - Warn = 3
 *    - Info = 4
 *    - Debug = 5
 *    - Trace = 6
 *   date__lt - datum do
 *
 *   date__gt - datum od
 * tags:
 *   - doc_checks
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           type: array
 *           items:
 *             $ref: '#/components/schemas/JobLog'
 *     description: ''
 * ```
 */
export const docChecksLogsListOperation = ({ id, ...rest }: DocChecksLogsListQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/doc_checks/${id}/logs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/doc_checks/{id}/logs/' };
  };

/**
 * GET /dmx-server/doc_checks/{id}/logs/
 *
 * ```yaml
 * operationId: doc_checks_logs_list
 * description: >-
 *   Slouží jako základ pro vytváření ViewSets pro zobrazení logů nad konkrétními
 *   objekty, např.
 *
 *   nad objednávkami, kontrolami.
 *
 *
 *   Nepovinne filtry
 *
 *   level - logovaci hladina je v rozmezi 1 - 6
 *    - Fatal = 1
 *    - Error = 2
 *    - Warn = 3
 *    - Info = 4
 *    - Debug = 5
 *    - Trace = 6
 *   date__lt - datum do
 *
 *   date__gt - datum od
 * tags:
 *   - doc_checks
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           type: array
 *           items:
 *             $ref: '#/components/schemas/JobLog'
 *     description: ''
 * ```
 */
export const docChecksLogsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocChecksLogsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<JobLogResponse[]>> => {
  const operation = docChecksLogsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/doc_checks/{id}/logs/
 */
export const useDocChecksLogsListResource = (
  query: DocChecksLogsListQuery | null,
  useCached?: boolean,
): UseResource<DocChecksLogsListResponse> => {
  return useResource<DocChecksLogsListResponse>({
    path: query === null ? null : docChecksLogsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
